module.exports = __webpack_public_path__ + "media/assets/images/ActivationPage/complex_organization-7928b6f97c1289333f3a16f12482d02a.png";